import { render } from "./CheckPersonalInfo.vue?vue&type=template&id=81653c46&scoped=true&ts=true"
import script from "./CheckPersonalInfo.vue?vue&type=script&lang=ts"
export * from "./CheckPersonalInfo.vue?vue&type=script&lang=ts"

import "./CheckPersonalInfo.vue?vue&type=style&index=0&id=81653c46&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81653c46"]])

export default __exports__